import { BaseDao } from './BaseDao';
import { ConstantMan } from '../constantMan';
import { ApiHelper } from '../apiHelper';
import { Observable } from 'rxjs';
import {ChannelMappingProvider} from "../../models/channelMappingProvider";
import {HttpHeaders} from "@angular/common/http";

export class ChannelMappingProviderDao extends BaseDao {
    constructor(apiHelper: ApiHelper) {
        super(ConstantMan.API.RESOURCE.CHANNELMAPPINGPROVIDERS, apiHelper);
    }

    public updateById(id: string, updates: Object): Observable<any> {
        const url = this.apiHelper.getServiceName() + this.getResource() + `/${id}`;
        const headers = this.apiHelper.getDefaultHeader();
        return this.apiHelper.apiCall(url, 'PUT', null, updates, headers);
    }
}

export interface GetProviderForBrandResponse {
    response: string;
    data: ChannelMappingProvider | null;
}
